import { Vue,Component,Emit,Prop,Watch} from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue'
import { toCamel } from 'snake-camel';
import moment from "moment";
import store from '@/assets/common/store/store';
import WorkItemBulkModal from "@/components/WorkItems/WorkItemBulkModal/WorkItemBulkModal.vue";



type WorkItem = {
    id: string;
    name: string;
    is_hidden: boolean;
    memo: string;
    isActive: boolean;
}

export type Item = {
    id: string;
    name: string;
    memo: string;
    isActive: boolean;
}


@Component({
    components: {
        Modal,
        WorkItemBulkModal
    }
})
export default class WorkItemsModal extends Vue {
    
    private list: any | null = null
    private items: any = []
    private title = '作業項目'
    private selectedWorkItem!: WorkItem
    private workItems: WorkItem[] = [];
    private bulkWorkItems: WorkItem[] = [];
    private selectedWorkItems!: WorkItem

    private withHidden = false
    private isLoading = false
    private headerTitle!: string
    private isHidden = false
    private searchText = ''
    private selectedItem = "";

    private baseUrl = '/work_items';
    private workItemsId = "";
    private workItemName = "";
    private workItemMemo = "";
    private alteredWorkItems = false
    private dialogVisible = false;

    @Prop() 
    isShowWorkItemsModal!: boolean

    @Watch('isShowWorkItemsModal')
    private showWorkItems() {
        this.getWorkItems(false)
    }

    @Watch('isShowWorkItemsModal')
    onModalVisibilityChanged(val: boolean) {
        this.$emit('update-inert', val)
    }

    @Watch('dialogVisible')
    onWorkItemBulkModalChanged(val: boolean) {
        this.$emit('work-bulk-inert', val)
    }

    private getWorkItems(withHidden: boolean) {
        this.list = null;
        this.isLoading = true
        this.$apiClient.doRequest('get', `${this.baseUrl}?with_hidden=${withHidden}`).then(res => {
            this.workItems = res.work_items as WorkItem[]
            this.list = this.workItems
            this.items = this.list
            if(this.selectedItem){
              this.isActive(this.selectedItem);
           }
        this.doSearch();
        })
        .finally(() => {
            this.isLoading = false
        })
    }

    private getBulkWorkItems() {
        this.openSideBar();
        this.isLoading = true;
        this.$apiClient.doRequest('get', `${this.baseUrl}?with_hidden=true`).then((ret) => {
            this.bulkWorkItems = ret.work_items;
            this.isLoading = false;
        });
    }

    private  openModal() {
        this.cancelEdit();
        if(this.alteredWorkItems == false){
            this.getBulkWorkItems();
            this.dialogVisible = true;
            this.$emit('work-bulk-inert',true)
        }
    }

    private toggleHiddenItems(value: boolean) {
        this.withHidden = !this.withHidden
        this.getWorkItems(this.withHidden)
    }


    private createWorkItems(flag: boolean) {
        this.inputChangedcheck()
        if(this.alteredWorkItems == false){
            this.selectedItem = ""
            this.headerTitle = "新規作業項目"
            this.workItemsId = "create"
            this.workItemName = ""
            this.workItemMemo = ""
            this.isHidden = false
            this.isActive(this.selectedItem);
            if(flag){
                this.openSideBar()
            }
        }
    }

    private setWorkItems(id: string, flag:boolean) {
        this.inputChangedcheck()
        this.headerTitle = "作業項目"
        if(this.alteredWorkItems == false && id != undefined){
            this.selectedItem = id;
            this.$apiClient.doRequest("get",  `${this.baseUrl}/${id}`).then((res) => {
                const item = this.selectedWorkItems = res as WorkItem
                this.workItemsId =  item.id
                this.workItemName = item.name
                this.workItemMemo = item.memo
                this.isHidden =  item.is_hidden

           })
           this.isActive(id);
        }
        if(flag){
            this.openSideBar();
        }
    }

    setItem(id: string, flag:boolean){
        if (id === this.selectedItem) {
            return;
        }
        this.setWorkItems(id,flag);
    }

   private isActive(id: string) {
        this.items?.forEach((item: any) => {
                item.isActive = item.id === id;
        });
    }
    private switchDisplay(isHidden: boolean) {
        if (!window.confirm(`${this.selectedWorkItems.name}を${ this.isHidden ? '表示状態に戻します' : '非表示にします' }。よろしいですか？`)){
            return
        }
        this.isLoading = true
            this.$apiClient.doRequest('put', `${this.baseUrl}/${this.workItemsId}/display?is_hidden=${!this.isHidden}`)
            .then((res) => {
            this.isHidden = !this.isHidden;
            this.getWorkItems(this.withHidden);
            this.$toasted.success(!this.isHidden ? '表示に変更しました。' : '非表示に変更しました。')
            })
            .catch(() => {
            this.$toasted.error('変更に失敗しました。')
            })
    }

    private cancelEdit() {
        if (this.alteredWorkItems) {
         const confirmed = window.confirm("変更内容を破棄します。よろしいですか。");
        if (!confirmed) {
            return;
        }
        }
        this.alteredWorkItems = false;
        if(this.workItemsId !== 'create') {
            this.setWorkItems(this.workItemsId, false)
        } else {
            this.createWorkItems(false)
        }
    }

    private validate() {
        const errmsg: string[] = []

        // 名前
        if(!this.workItemName.trim()){
            errmsg.push('作業名を入力してください')
        }
        // 名前の長さ
        if(this.workItemName.length > 100){
            errmsg.push(`作業名は100文字以内で入力してください（現在は${this.workItemName.length}文字）`)
        }
        // メモ
        if(this.workItemMemo && this.workItemMemo.length > 21844) {
            errmsg.push(`メモは21844文字以内で入力してください（現在は${this.workItemMemo.length}文字）`)
        }

        if(errmsg.length > 0) {
            window.alert(errmsg.join('\n'))
            return false
        }

        return true
    }

    private submit(isHiddenUpdate: boolean) {
        if(!this.validate()) {
            return;
        }
        const newWorkItem = {
            id: this.workItemsId,
            name: this.workItemName.trim(),
            memo: this.workItemMemo.trim(),
            is_hidden: this.isHidden
        }
        if( newWorkItem.id === 'create'){
        this.$apiClient.doRequest('post', this.baseUrl, newWorkItem).then((res) => {
            this.getWorkItems(this.withHidden)
                setTimeout(() => {
                    this.setWorkItems(res.id, false)
                }, 200);
            this.$toasted.success('保存しました。')
        })
        .catch(() => {
            this.$toasted.error('保存に失敗しました。')
        })
        } else {
            const result = window.confirm("内容を上書きして保存します。よろしいですか。")
            if(!result) {
                return false;
            }
            this.$apiClient.doRequest('put', `${this.baseUrl}/${this.workItemsId}`, newWorkItem).then((res) => {
                this.getWorkItems(this.withHidden)
                setTimeout(() => {
                    this.setWorkItems(res.id, false)
                }, 200);
                this.$toasted.success('変更を保存しました。')
            })
            .catch(() => {
                this.$toasted.error('変更に失敗しました。')
            })
        }
        this.alteredWorkItems = false
        this.searchText = ''
    
    }

  @Emit('inputChanged')
    inputChanged(){
        if(this.alteredWorkItems == false){
            this.alteredWorkItems = true
        }
    }

    closeModal(){
            if (this.alteredWorkItems && !window.confirm("変更内容を破棄します。よろしいですか？")) {
            return;
            }
            this.$emit('update:isShowWorkItemsModal', false);
            this.workItemsId = "";
            this.workItemName = "";
            this.workItemMemo = "";
            this.alteredWorkItems= false
            this.items = [];
            this.withHidden = false;
            this.selectedItem = ''
            this.searchText = ''
    }

    @Watch('searchText')
    private doSearch() {
    const keyword = this.searchText?.trim() ?? '';
        if (!keyword) {
            this.items = this.list;
            return;
        }
        this.items = this.list?.filter((item: Item) => item.name.indexOf(this.searchText) > -1)
    }
    
    openSideBar = () => {
        const isResponsive = window.matchMedia('(max-width: 1000px)').matches;
        if (!isResponsive) {
            return; 
        }
        if(document.body.classList.contains('newsSide')){
            document.body.classList.remove('newsSide')
        }else{
            document.body.classList.add('newsSide')
        }
    }

    inputChangedcheck(){
        if(this.alteredWorkItems==true){
        const confirm = window.confirm('変更内容を破棄します。よろしいですか？')
        if(confirm){
            this.alteredWorkItems = false
        }
        }
    }
         
}      